import { Component, OnInit } from '@angular/core';
import { DataGridTemplate } from '../../../../shared/data-grid/data-grid.template';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { FormDialogTemplate } from '../../../../shared/form-dialog/form-dialog.template';
import { BehaviorSubject, Subject } from 'rxjs';
import { DieFamilyService } from '../../phf.service';


@Component({
  selector: 'die-family',
  templateUrl: './die-family.component.html'
})
export class DieFamilyComponent extends DataGridTemplate implements OnInit {
  editForm: FormGroup;
  formDialog: FormDialogTemplate;
  dialogTitle: BehaviorSubject<string> = new BehaviorSubject<string>(undefined);

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly dieFamilyService: DieFamilyService,
  ) {
    super();
  }

  ngOnInit() {
    this.httpErrorHeader = "Die Family Error";
    this.filterable = "menu";
    this.formDialog = new FormDialogTemplate();
    this.modal = true;
    this.formDialog.setHeight(480);
    this.controls.excel = true;
    this.editForm = this.formBuilder.group({
      Id: [],
      Description: ['', Validators.required],
      IsActive: [],
    });
    this.formDialog.initilize(this.dialogTitle, this.editForm, this.formDialogTabs);

    this.dialogTitle.next('Die Family');
  }

  private readonly ngUnsubscribe: Subject<void> = new Subject<void>();

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
    this.dialogTitle.complete();
  }

  read(opts: any): Promise<any> {
    if (opts.force) {
      return this.dieFamilyService.read()
        .then(response => {
          return response;
        })
    }
    else {
      return Promise.resolve(this.dieFamilyService.value);
    }
  }

  create(parentEditDataItem: any): void {
    this.formDialog.isNew = true;
    this.formDialog.next({});
  }


  edit(dataItem: any): void {
    this.formDialog.isNew = false;
    this.formDialog.next(dataItem);
  }

  save(dataItem: any, isNew: boolean): Promise<any> {
    dataItem.IsActive = true;
    return isNew ?
      this.dieFamilyService.save(dataItem, isNew, "", false)
      : this.dieFamilyService.save(dataItem, isNew, "/" + dataItem.Id, false);
  }

  delete(dataItem: any): Promise<any> {
    return this.dieFamilyService.remove('/' + dataItem.Id, false);
  }

  columns: any[] = [
    {
      field: 'Description',
      title: 'Description',
      width: '*',
      sortable: true,
    },
  ]
  formControls = [
    {
      type: "textarea",
      name: "Description",
      title: "Description",
      stretch: true,
    },
  ]

  formDialogTabs = [
    {
      title: "Die Family",
      selected: true,
      formControls: this.formControls
    },
  ]
}
